import React from "react";

const AppLogoLoading = () => <lottie-player src={process.env.PUBLIC_URL + '/assets/images/app-logo-loading.json'} background="transparent" style={{ width: '300px', height: '300px' }} speed="1" loop autoplay />;

export default AppLogoLoading;